import React from 'react'
import { LocalizationProvider, TimeField } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'

const AnTimeField = (props) => (
  <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en-gb">
    <TimeField
      value={props.time ? moment(props.time) : null}
      onChange={props.onChange}
      label={props.label}
      sx={props.sx}
      autoComplete="off"
      fullWidth
      name="time"
      {...props}
    />
  </LocalizationProvider>
)

export default AnTimeField
